import { Button, Form, Input, Space } from "antd";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../app/store";
import InfoIcon from "../../../assets/icons/InfoIcon";
import CustomModal from "../../../components/ui/CustomModal";
import Loader from "../../../components/ui/Loader";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import { useGetSingleBatchQuery } from "../batch/batchApi";
import { useGetSingleCompanyQuery } from "../companyOnboard/companyOnboardApi";
import ApprovedModal from "./ApprovedModal";
import { useVerifyPinMutation } from "./vendorPaymentApi";

type PinVerifyModalProps = {
  open: boolean;
  handleClose: () => void;
  refetch: () => void;
  paymentApi: (data: any) => void;
  isPaymentSuccess: boolean;
  isPaymentLoading: boolean;
  paymentMessage: string;
  batchId?: string | number;
};

const PinVerifyModal = ({
  open,
  handleClose,
  batchId,
  ...rest
}: PinVerifyModalProps) => {
  const [pin, setPin] = useState<string | undefined>(undefined);

  const {
    open: approverOpen,
    handleClose: handleApproverClose,
    handleOpen,
  } = useModal<string | undefined, "APPROVE">();
  const [
    verifyPin,
    {
      isError: isVerifyPinError,
      error: verifyPinError,
      isLoading: isVerifyPinLoading,
      isSuccess: isVerifyPinSuccess,
      data: verifyPinData,
    },
  ] = useVerifyPinMutation();
  const { user } = useAppSelector((state) => state.auth);
  const {
    isLoading: isCompanyDetailsLoading,
    isError: isCompanyDetailsError,
    error: companyDetailsError,
    data: companyDetails,
  } = useGetSingleCompanyQuery(user?.data?.company_id, {
    skip: !user?.data?.company_id,
  });

  const {
    isError: singleBatchIsError,
    error: singleBatchError,
    data: singleBatchData,
  } = useGetSingleBatchQuery(batchId, {
    skip: !batchId,
  });

  useError(isVerifyPinError, verifyPinError, "PIN verify fail");
  useError(isCompanyDetailsError, companyDetailsError, "Get company data fail");
  useError(singleBatchIsError, singleBatchError, "Get single batch fail");

  //   const handleVerifyOtp = (values: any) => {
  //     const otpRequestData = {
  //       App_Version: "4.1.0",
  //       Device_Id: deviceId,
  //       Device_Password: otpData?.Password,
  //       FullName: "SP1A.210812.016",
  //       LANG: "bn",
  //       OTP: values?.OTP,
  //       Os_Version: "12",
  //       Phone_Brand: "itel S665L",
  //       Phone_Os: "android",
  //       Username: companyDetails?.data?.wallet_number,
  //       companyId: user?.data?.company_id,
  //     };

  //     verifyPin(otpRequestData);
  //   };

  const handleVerifyPin = (values: any) => {
    verifyPin({
      data: {
        Username: companyDetails?.data?.wallet_number, // old
        // Username: singleBatchData?.data?.wallet_number, // new
        Pin: values?.pin,
      },
      headers: {
        Module: "JW9tc0ByZWRsdGQl",
      },
    });
  };

  useEffect(() => {
    if (isVerifyPinSuccess) {
      handleOpen({ type: "APPROVE", data: verifyPinData });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVerifyPinSuccess, verifyPinData]);

  return (
    <>
      <CustomModal
        open={open}
        handleClose={handleClose}
        width={400}
        footer={null}
      >
        {approverOpen?.open && (
          <ApprovedModal
            {...rest}
            open={approverOpen?.open}
            handleClose={() => {
              handleApproverClose();
              handleClose();
            }}
            data={pin}
            batchId={batchId}
          />
        )}
        <div className="flex items-center gap-2">
          <span className="bg-[#FFF6ED] p-1 rounded">
            <InfoIcon />
          </span>
          <span className="text-[22px] font-semibold">Verify PIN</span>
        </div>
        {isCompanyDetailsLoading ? (
          <Loader />
        ) : !companyDetails?.data?.wallet_number ? (
          <div>
            <div className="mt-4 text-center justify-center text-red-600 text-sm font-normal leading-normal">
              Wallet number not found, please set wallet number
            </div>
          </div>
        ) : (
          <div className="mt-4">
            <Form
              className="custom-form"
              requiredMark="optional"
              layout="vertical"
              onFinish={handleVerifyPin}
            >
              <Form.Item
                label="PIN Number"
                name="pin"
                rules={[
                  {
                    required: true,
                    message: "Please Enter PIN Number",
                  },
                  {
                    pattern: /^\d{6,}$/,
                    message: "PIN number must be at least 6 digits",
                  },
                ]}
              >
                <Input.Password
                  placeholder="Enter PIN Number"
                  onChange={(e) => setPin(e.target.value)}
                />
              </Form.Item>
              <Space className="w-full mt-3" size={12}>
                <Button
                  className="normal-dark-button modal-button"
                  onClick={handleClose}
                  size="middle"
                >
                  Cancel
                </Button>
                <Button
                  className="modal-button"
                  type="primary"
                  htmlType="submit"
                  size="middle"
                  loading={isVerifyPinLoading}
                >
                  Verify
                </Button>
              </Space>
            </Form>
          </div>
        )}
      </CustomModal>
    </>
  );
};

export default PinVerifyModal;
